module.exports = __webpack_public_path__ + "static/media/spotify-logo.6a8759c0.png";